"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../../bind");
var elog = require("@reverbdotcom/commons/dist/elog");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var react_apollo_1 = require("react-apollo");
var rql_1 = require("../../schemas/rql");
var wrapped_location_1 = require("../../lib/wrapped_location");
var threeds2_checkout_operations_1 = require("./threeds2_checkout_operations");
var threeds2_checkout_submission_1 = require("./threeds2_checkout_submission");
var threeds2_interaction_1 = require("./threeds2_interaction");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var TAG = 'adyen.threeds2_checkout_container';
var ThreeDS2CheckoutContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeDS2CheckoutContainer, _super);
    function ThreeDS2CheckoutContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            fingerprintToken: _this.props.fingerprintToken,
            challengeToken: _this.props.challengeToken,
            paymentStatus: _this.props.paymentStatus,
        };
        return _this;
    }
    Object.defineProperty(ThreeDS2CheckoutContainer.prototype, "totalPrice", {
        get: function () {
            return {
                amountCents: this.props.totalAmountCents,
                currency: this.props.currency,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThreeDS2CheckoutContainer.prototype, "resultCallbacks", {
        get: function () {
            return {
                onSuccess: this.onSuccess,
                onChallengeShopperRequired: this.onChallengeShopperRequired,
                onError: this.onThreeDSFailed,
            };
        },
        enumerable: true,
        configurable: true
    });
    ThreeDS2CheckoutContainer.prototype.eventData = function (additionalContext) {
        if (additionalContext === void 0) { additionalContext = {}; }
        return {
            componentName: 'ThreeDS2CheckoutContainer',
            context: tslib_1.__assign({ props: tslib_1.__assign({}, this.props), state: tslib_1.__assign({}, this.state) }, additionalContext),
        };
    };
    ThreeDS2CheckoutContainer.prototype.componentDidMount = function () {
        tracker_1.trackView(this.eventData());
        elog.info(TAG + ".mount", tslib_1.__assign({}, this.eventData()));
    };
    ThreeDS2CheckoutContainer.prototype.onChallengeShopperRequired = function (challengeToken) {
        this.setState({
            challengeToken: challengeToken,
            paymentStatus: rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.CHALLENGE_SHOPPER_REQUIRED,
        });
    };
    ThreeDS2CheckoutContainer.prototype.onIdentifyShopperComplete = function (fingerprintResult) {
        threeds2_checkout_submission_1.submitCheckoutIdentifyShopper({
            checkoutUuid: this.props.checkoutUUID,
            checkoutId: this.props.checkoutID,
            totalPrice: this.totalPrice,
            results: {
                threeds2FingerprintResult: fingerprintResult,
                paymentData: this.props.paymentData,
            },
            channelBrandingToken: this.props.channelBrandingToken,
        }, this.props.checkoutIdentifyShopper, this.resultCallbacks);
    };
    ThreeDS2CheckoutContainer.prototype.onChallengeShopperComplete = function (challengeResult) {
        threeds2_checkout_submission_1.submitCheckoutChallengeShopper({
            checkoutUuid: this.props.checkoutUUID,
            checkoutId: this.props.checkoutID,
            totalPrice: this.totalPrice,
            results: {
                threeds2ChallengeResult: challengeResult,
                paymentData: this.props.paymentData,
            },
            channelBrandingToken: this.props.channelBrandingToken,
        }, this.props.checkoutChallengeShopper, this.resultCallbacks);
    };
    ThreeDS2CheckoutContainer.prototype.onGuestCheckoutIdentifyShopper = function (fingerprintResult) {
        threeds2_checkout_submission_1.submitGuestCheckoutIdentifyShopper({
            checkoutUuid: this.props.checkoutUUID,
            checkoutId: this.props.checkoutID,
            totalPrice: this.totalPrice,
            results: {
                threeds2FingerprintResult: fingerprintResult,
                paymentData: this.props.paymentData,
            },
            channelBrandingToken: this.props.channelBrandingToken,
            cartItemAttributes: this.props.cartItemAttributes,
        }, this.props.guestCheckoutIdentifyShopper, this.resultCallbacks);
    };
    ThreeDS2CheckoutContainer.prototype.onGuestChallengeShopperComplete = function (challengeResult) {
        threeds2_checkout_submission_1.submitGuestCheckoutChallengeShopper({
            checkoutUuid: this.props.checkoutUUID,
            checkoutId: this.props.checkoutID,
            totalPrice: this.totalPrice,
            results: {
                threeds2ChallengeResult: challengeResult,
                paymentData: this.props.paymentData,
            },
            channelBrandingToken: this.props.channelBrandingToken,
            cartItemAttributes: this.props.cartItemAttributes,
        }, this.props.guestCheckoutChallengeShopper, this.resultCallbacks);
    };
    ThreeDS2CheckoutContainer.prototype.onSuccess = function (paymentResultUrl) {
        elog.info(TAG + ".success", {
            checkoutID: this.props.checkoutID,
            checkoutUUID: this.props.checkoutUUID,
            paymentStatus: this.props.paymentStatus,
        });
        wrapped_location_1.default.assign(paymentResultUrl);
    };
    ThreeDS2CheckoutContainer.prototype.onThreeDSFailed = function (errors) {
        elog.info(TAG + ".failed", {
            errors: errors,
            checkoutUuid: this.props.checkoutUUID,
            orderBundleId: this.props.checkoutID,
            paymentStatus: this.state.paymentStatus,
        });
        wrapped_location_1.default.assign(this.props.redirectOnFailureUrl);
    };
    ThreeDS2CheckoutContainer.prototype.render = function () {
        if (this.props.user.loggedOut) {
            return (React.createElement(threeds2_interaction_1.default, { challengeToken: this.state.challengeToken, fingerprintToken: this.state.fingerprintToken, onChallengeShopperComplete: this.onGuestChallengeShopperComplete, onIdentifyShopperComplete: this.onGuestCheckoutIdentifyShopper, paymentStatus: this.state.paymentStatus }));
        }
        return (React.createElement(threeds2_interaction_1.default, { challengeToken: this.state.challengeToken, fingerprintToken: this.state.fingerprintToken, onChallengeShopperComplete: this.onChallengeShopperComplete, onIdentifyShopperComplete: this.onIdentifyShopperComplete, paymentStatus: this.state.paymentStatus }));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2CheckoutContainer.prototype, "onChallengeShopperRequired", null);
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2CheckoutContainer.prototype, "onIdentifyShopperComplete", null);
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2CheckoutContainer.prototype, "onChallengeShopperComplete", null);
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2CheckoutContainer.prototype, "onGuestCheckoutIdentifyShopper", null);
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2CheckoutContainer.prototype, "onGuestChallengeShopperComplete", null);
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2CheckoutContainer.prototype, "onSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2CheckoutContainer.prototype, "onThreeDSFailed", null);
    return ThreeDS2CheckoutContainer;
}(React.Component));
exports.ThreeDS2CheckoutContainer = ThreeDS2CheckoutContainer;
exports.default = react_apollo_1.compose(threeds2_checkout_operations_1.connectCheckoutIdentifyShopper, threeds2_checkout_operations_1.connectCheckoutChallengeShopper, threeds2_checkout_operations_1.connectGuestCheckoutIdentifyShopper, threeds2_checkout_operations_1.connectGuestCheckoutChallengeShopper)(user_context_provider_1.withUserContext(ThreeDS2CheckoutContainer));
//# sourceMappingURL=threeds2_checkout_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/threeds2/threeds2_checkout_container.js
// module id = JRpt
// module chunks = 20 21 22